import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanMatch, GuardResult, MaybeAsync,
  Route,
  Router,
  RouterStateSnapshot, UrlSegment,
  UrlTree
} from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanMatch {

  constructor(private router: Router, private authService: AuthService) { }

  public canActivate(): boolean | UrlTree {
    return this._checkAccess();
  }

  public canMatch(): boolean | UrlTree {
    return this._checkAccess();
  }

  protected _checkAccess(): boolean | UrlTree {
    if (!this.authService.isAuthenticatedUser()) {
      console.log('not authenticated');
      return this.router.parseUrl('/login');
    }

    return true;
  }
}
